import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91f22d2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap gap-1 justify-content-start" }
const _hoisted_2 = { class: "table mb-0" }
const _hoisted_3 = { class: "borda mt-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = ["onClick", "onDblclick"]
const _hoisted_10 = { class: "col-sm-1 col-md-1 py-0" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["colspan"]
const _hoisted_14 = ["colspan"]
const _hoisted_15 = ["colspan"]
const _hoisted_16 = ["colspan"]

import services from '@/services';
import atendProcedimentos from '@/services/atendProcedimentos';
import { reactive, onMounted } from 'vue';
// import configuracoes from '@/../public/config/config.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'GridDorape',
  props: ['linhas', 'colunas', 'dados', 'profissional',
    'agendarCard', 'visualizarAtend', 'gerarAtend', 'pacienteCadastrado',
    'lstAgendaPacienteCadastrado', 'usarNomeSocial', 'retornaPossuiPermissao',
    'tamanho'],
  emits: ['abrirProntuario', 'abrirOpcoes'],
  setup(__props, { emit: emits }) {

const props = __props;



const state = reactive({
    arrow: Array<number>(), //[Number()],
    lst: [],
    ordenacao: ["", "asc", "desc"],

    config: Object() as any,

    carregando: Boolean(),
    telaCelular: Boolean(true),
    telaPequena: Boolean(true),

    ordenarAux: Number(),
    ordenarNumAnterior: Number(),

    agendados: Number(),
    emAtendimento: Number(),
    fechados: Number(),
    vagos: Number(),
});

function tamanho() {
    setInterval(() => {
        (window.innerWidth <= 1023) ? state.telaCelular = true : state.telaCelular = false;
        (window.innerWidth <= 1400) ? state.telaPequena = true : state.telaPequena = false;
    }, 100);
}

async function abrirProntuario(pObj: any) {
    if (state.telaPequena) {
        const { data, erros } = await services.agenda.ListarPorId(pObj.idAgenda);
        if (!erros) {
            if (data.status == "AT" || data.status == "FE") {
                // console.log(data.status);
                emits('abrirProntuario', data);
            }
        }
    }
}

async function abrirOpcoes(pObj: any) {
    if (state.telaPequena) {
        if (pObj.agendado) {
            if (pObj.status != "FA" && pObj.status != "DE")
                emits("abrirOpcoes", pObj);
        }
    }
}

async function abrirOpcoesGrande(pObj: any) {
    if (pObj.agendado) {
        if (pObj.status != "FA" && pObj.status != "DE")
            emits("abrirOpcoes", pObj);
    }
}

async function retornaProcedimentoDescricao(pId: any) {
    // const { data, erros } = await services.agendaProcedimento.ListarPorId(pId);

    // if (!erros) {
    // debugger;
    // console.log(data[0].procedimento.descricao);
    //     return await data[0].procedimento.descricao;
    // }
    // console.log(pId);
}

onMounted(async () => {
    tamanho();
    // console.log(props.dados);
    props.dados.forEach((d: any) => {
        // console.log(d.status);
        if (d.agendado == false || d.status == "DE")
            state.vagos++;
        if (d.status == "AG")
            state.agendados++;
        if (d.status == "AT" || d.status == "AO")
            state.emAtendimento++;
        if (d.status == "FE")
            state.fechados++;
    });

    state.config = await fetch("../config/config.json")
        .then(resp => {
            return resp.json();
        });

    // console.log(state.config);

});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colunas, (a, index) => {
            return (_openBlock(), _createElementBlock("td", {
              class: _normalizeClass(["fs-5 fw-bold", `coluna${a}`]),
              key: index
            }, [
              (a != 'Sala')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(a), 1))
                : _createCommentVNode("", true),
              (a == 'Sala' && state.config.mostrarSala)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(a), 1))
                : _createCommentVNode("", true),
              (state.arrow[index] === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "▲"))
                : (state.arrow[index] === 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "▼"))
                  : (state.arrow[index] === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                    : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _withDirectives(_createElementVNode("td", {
            class: _normalizeClass(["fs-5 fw-bold text-center", { 'telaNormal': state.telaPequena == false, 'telaPequena': state.telaPequena == true }])
          }, " Informações Adicionais ", 2), [
            [_vShow, state.telaCelular == false]
          ])
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dados, (d, index) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: index,
            class: _normalizeClass({
                    AgendFechado: d?.status === 'FE',
                    Alert: d?.status === 'FA',
                    AguardAtend: d?.status === 'AO',
                    EmAtend: d?.status === 'AT',
                    HBlock: d?.status === 'BQ',
                    'HCanc cursor-default': d?.status === 'DE',
                    PacCad: d?.status === 'AG',
                    'Canc cursor-default': d?.status === 'CA'

                })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.linhas, (l, i) => {
              return (_openBlock(), _createElementBlock("td", {
                key: i,
                class: _normalizeClass(["py-1", { 'campoLinhaNomePac': l == 'nomePaciente', 'campoLinhaConvenio': l == 'nomeConvenio' }]),
                onClick: ($event: any) => (abrirOpcoes(d)),
                onDblclick: ($event: any) => (abrirOpcoesGrande(d))
              }, [
                (l != 'Procedimento' && l != 'sala')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({
                            'texto-inativo': d.ativo === false, 'pointer': d.status == 'FE' || d.status == 'AT', 'fonte': d.status != 'AB',
                        })
                    }, _toDisplayString(d[l]), 3))
                  : _createCommentVNode("", true),
                (state.config.mostrarSala == true && l == 'sala')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: _normalizeClass({
                            'texto-inativo': d.ativo === false, 'pointer': d.status == 'FE' || d.status == 'AT', 'fonte': d.status != 'AB',
                        })
                    }, _toDisplayString(d[l]), 3))
                  : _createCommentVNode("", true)
              ], 42, _hoisted_9))
            }), 128)),
            _withDirectives(_createElementVNode("td", _hoisted_10, [
              _withDirectives(_createElementVNode("button", {
                class: "btn btn-dark btn-full",
                onClick: ($event: any) => (__props.visualizarAtend(d, 'Agenda'))
              }, "Agendamento", 8, _hoisted_11), [
                [_vShow, (d?.status == 'AO' || d?.status == 'AG') && state.telaCelular == false]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "btn btn-dark btn-full",
                onClick: ($event: any) => (__props.visualizarAtend(d, 'Atendimento'))
              }, "Atendimento", 8, _hoisted_12), [
                [_vShow, (d?.status == 'FE' || d?.status == 'AT') && state.telaCelular == false]
              ])
            ], 512), [
              [_vShow, state.telaCelular == false]
            ])
          ], 2))
        }), 128)),
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: __props.linhas.length + 1
          }, " Agendados - " + _toDisplayString(state.agendados), 9, _hoisted_13)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: __props.linhas.length + 1
          }, " Em Atendimento - " + _toDisplayString(state.emAtendimento), 9, _hoisted_14)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: __props.linhas.length + 1
          }, " Fechados - " + _toDisplayString(state.fechados), 9, _hoisted_15)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            colspan: __props.linhas.length + 1
          }, " Vagos - " + _toDisplayString(state.vagos), 9, _hoisted_16)
        ])
      ])
    ]),
    _renderSlot(_ctx.$slots, "ficha")
  ]))
}
}

})